import { george, i18n, pr, React, theme, ui } from "aaa";
import { IconTPPConnection, STYLE_CENTERED_CARD } from "components/util/primitives";
import { observer } from "mobx-react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";

// Hardcoded text color to match svg fill
export const TPPEmptyList = observer(({ useCard }: { useCard?: boolean }) => {
    return (externalInterfaceStore.isGeorgeApp && !useCard) ? (
        <>
            <pr.HFlexCentered
                style={{
                    padding: theme.MARGIN_LARGE,
                    paddingBottom: 0,
                    paddingTop: theme.MARGIN,
                    marginTop: externalInterfaceStore.isGeorgeApp ? undefined : theme.MARGIN_XLARGE
                }}
            >
                <IconTPPConnection className="theme-paragraph-color" />
            </pr.HFlexCentered>
            <pr.P_22_TITLE className="theme-paragraph-color" style={{ fontWeight: "bold", textAlign: "center", marginBottom: theme.MARGIN_SMALL }}>
                {ui.__("tpp.emptylist.paragraph.one")}
            </pr.P_22_TITLE>
            <pr.HCenterDiv>
                <pr.P_16_CONTENT>
                    <i18n.FormattedHTMLMessage id="tpp.emptylist.paragraph.two" />
                </pr.P_16_CONTENT>
            </pr.HCenterDiv>
        </>
    ) : (
        <george.Card
            disableTopSpacing
            style={{
                borderRadius: 8,
                boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.05)",
                ...STYLE_CENTERED_CARD
            }}
        >
            <pr.HFlexCentered
                style={{
                    padding: theme.MARGIN_LARGE,
                    paddingBottom: 0,
                    paddingTop: theme.MARGIN,
                    marginTop: externalInterfaceStore.isGeorgeApp ? undefined : theme.MARGIN_XLARGE
                }}
            >
                <IconTPPConnection className="theme-paragraph-color" />
            </pr.HFlexCentered>
            <pr.HCenterDiv style={{ marginBottom: theme.MARGIN_SMALL }}>
                <pr.P_24_TITLE className="theme-paragraph-color" style={{ fontWeight: "bold" }}>
                    {ui.__("tpp.emptylist.paragraph.one")}
                </pr.P_24_TITLE>
            </pr.HCenterDiv>
            <george.CardSectionContent style={{ paddingBottom: theme.MARGIN_LARGE }}>
                <pr.HCenterDiv>
                    <pr.P_16_CONTENT>
                        <i18n.FormattedHTMLMessage id="tpp.emptylist.paragraph.two" />
                    </pr.P_16_CONTENT>
                </pr.HCenterDiv>
            </george.CardSectionContent>
        </george.Card>
    );
});



// WEBPACK FOOTER //
// ./src/components/tpp/TPPEmptyList.tsx